import { type Scene } from "three";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import ModelNotReadyException from "@/features/model-renderer/exceptions/ModelNotReadyException.ts";
import Logger from "@/lib/logger.ts";
import Resources from "../utils/Resources.ts";
import SceneHelpers from "../utils/SceneHelpers.ts";

export default class Model {
    readonly #sceneHelpers: SceneHelpers;

    constructor(scene: Scene) {
        this.#sceneHelpers = new SceneHelpers(scene);
    }

    init() {
        Logger.info("Adding model to scene");
        DiagnosticsStore.collectEventLog("info", "Adding model to scene");

        const model = Resources.getInstance().model;
        if (!model) throw new ModelNotReadyException();

        this.#sceneHelpers.scene.add(model.scene);
    }
}
